import { observer } from 'mobx-react';
import * as React from 'react';
import ModalStore from '../../../Modal/Store';
import LearningCollectionsStore from '../../Store';
import { LearningCollectionSummaryResource } from '../../Types';
import CloneStore from './Clone/Store';
import CollaboratorAccessStore from './CollaboratorAccess/Store';
import LearningCollectionListItemState from './LearningCollectionListItemState';
import LearningCollectionStore from './Store';
import LearningCollectionReactions from './Store/Reactions';

interface Props {
  store: LearningCollectionsStore;
  learningCollectionSummaryResource: LearningCollectionSummaryResource;
  totalLength?: number;
}

class LearningCollectionListItem extends React.Component<Props> {
  shareModalStore: ModalStore = new ModalStore();
  hideModalStore: ModalStore = new ModalStore();
  cloneStore: CloneStore = new CloneStore();
  collaboratorAccessStore: CollaboratorAccessStore = new CollaboratorAccessStore();
  learningCollectionStore: LearningCollectionStore = new LearningCollectionStore(this.props.store);

  componentDidMount() {
    this.learningCollectionStore.loading(this.props.learningCollectionSummaryResource);
  }

  componentDidUpdate(prevProps: Props) {
    // Update the store when the resource prop changes (e.g., after refetch)
    if (
      prevProps.learningCollectionSummaryResource !== this.props.learningCollectionSummaryResource
    ) {
      this.learningCollectionStore.updateResource(this.props.learningCollectionSummaryResource);
    }
  }

  render() {
    return (
      <>
        <LearningCollectionListItemState
          shareModalStore={this.shareModalStore}
          hideModalStore={this.hideModalStore}
          cloneStore={this.cloneStore}
          collaboratorAccessStore={this.collaboratorAccessStore}
          learningCollectionStore={this.learningCollectionStore}
          totalLength={this.props.totalLength}
        />
        <LearningCollectionReactions store={this.learningCollectionStore} />
      </>
    );
  }
}

export default observer(LearningCollectionListItem);
